import { render, staticRenderFns } from "./Telegram.vue?vue&type=template&id=2bbc9688"
import script from "./Telegram.vue?vue&type=script&lang=js"
export * from "./Telegram.vue?vue&type=script&lang=js"
import style0 from "./Telegram.vue?vue&type=style&index=0&id=2bbc9688&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports